// extracted by mini-css-extract-plugin
module.exports = {"separator":"select_separator_separator__30uKL"};